import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { Pitch, PitchesParams } from '../pitches.interface';
import { AppViews } from 'src/app/shared/helpers/enums';

export const setPitches = createAction(
  '[Pitches Component] Set Pitches',
  props<{ pitches: BackendResponse<Pitch>; params: PitchesParams; pageNumber: number }>()
);

export const updatePitches = createAction('[Pitches Component] Update Pitches', props<{ pitches: Pitch[] }>());

export const updatePitch = createAction('[Pitches Component] Update Pitch', props<{ pitch: Pitch }>());

export const switchSelection = createAction('[Pitches Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Pitches Component] Switch All Selection', props<{ checked: boolean }>());

export const switchAdvancedOptions = createAction('[Pitches Component] Switch Advanced Options');

// Requests

export const loadPitches = createAction('[Request/Api Pitches] Load Pitches', (params: PitchesParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));

export const changePitchesFeaturedStatus = createAction(
  '[Request/Api Pitches] Change Pitches Featured Status',
  props<{ payload: { ids: string[]; visibility: string } }>()
);

export const switchPitchFeaturedStatus = createAction(
  '[Request/Api Pitches] Switch Pitch Featured Status',
  props<{ id: string; appView: AppViews }>()
);
